import { environment } from '../../environments/environment';

export const ROOT_URL: string = environment.ROOT_URL;
export const IMG_ROOT_URL: string = environment.tockenURL;